import Breadcrumb from "../components/Breadcrumb";
import VehicleManagement from "../components/VehicleManagement";

const VehicleManagementPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Client Hierarchy" />

      <VehicleManagement />
    </>
  );
};

export default VehicleManagementPage;
